import React from 'react';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import MarketingModal from './MarketingModal';
import navigatorW622Src from './navigator-w622.jpg';
import navigatorW864Src from './navigator-w864.jpg';
import navigatorW864AvifSrc from './navigator-w864.avif';
import navigatorW622AvifSrc from './navigator-w622.avif';
import * as styles from './styles/styles.module.scss';
import { MEDIA_QUERY_SMALL_DOWN } from '../../utils/constants/breakpoints';

const {
  strings: {
    DOWNLOAD_THE_ALLTRAILS_APP,
    NAVIGATOR_MODAL: { NAVIGATOR_IS_ONLY, APP_ONLY_FEATURE }
  }
} = StringConstantsMixin;

function NavigatorModal() {
  const languageRegionCode = useLanguageRegionCode();

  const Picture = (
    <picture>
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={navigatorW622AvifSrc} type="image/avif" />
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={navigatorW622Src} />
      <source srcSet={navigatorW864AvifSrc} type="image/avif" />
      <img className={styles.img} src={navigatorW864Src} />
    </picture>
  );

  if (languageRegionCode === LanguageRegionCode.English) {
    return <MarketingModal headerText={DOWNLOAD_THE_ALLTRAILS_APP} instructionsText={NAVIGATOR_IS_ONLY} picture={Picture} />;
  }

  return <MarketingModal headerText={APP_ONLY_FEATURE} instructionsText={NAVIGATOR_IS_ONLY} picture={Picture} />;
}

export default NavigatorModal;
